<template>
  <SogCard class="sog-card">
    <SogCardContent>
      <div
        v-if="props.isInvoice || props.isDelivery"
        class="address-types"
      >
        <v-icon
          v-if="props.isInvoice"
          icon="mdi-receipt-text"
          class="address-type-icon"
          title="Rechnungsadresse"
        />
        <v-icon
          v-if="props.isDelivery"
          icon="mdi-truck-delivery"
          class="address-type-icon"
          title="Lieferadresse"
        />
      </div>
      <SogFlexColumn>
        <span v-show="props.address?.fullName"><SogDataLabel :value="props.address?.fullName" /></span>
        <span v-show="props.address?.line1 && props.address?.line1!==''"><SogDataLabel :value="props.address?.line1" /></span>
        <span><SogDataLabel :value="props.address?.street" /> <SogDataLabel :value="props.address?.houseNumber" /><SogDataLabel :value="props.address?.houseNumberAddition" /></span>
        <span><SogDataLabel :value="props.address?.postalCode" /> <SogDataLabel :value="props.address?.city" /></span>
        <SogDataLabel :value="props.address?.countryName" />
      </SogFlexColumn>
    </SogCardContent>
    <slot />
  </SogCard>
</template>

<script setup lang="ts">
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import Address from "@/shared/model/Address";
import SogFlexColumn from "@/shared/ui/SogFlexColumn.vue";
import SogDataLabel from "@/shared/ui/SogDataLabel.vue";


interface Props {
  address?:Address
  isInvoice?: boolean
  isDelivery?: boolean
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
  address:undefined,
  isInvoice: false,
  isDelivery: false,
  }
)
/*const _classCard = computed(()=>{
  let res = "sog-card"
  if(props.isSelected){
    res += " selected"
  }
  if(props.allowSelect){
    res += " allow-select"
  }
  return res

})*/

</script>

<style scoped>
td{
  padding-right:10px;
}
/*.sog-card{
  /*
  min-width: 100px;
  width: auto;

  padding-top: 12px;
}*/
.sog-card{
  min-width: 250px;
  width: 250px;
  padding-top: 12px;
}

.address-types{
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-bottom: 4px;
}

.address-type-icon{
  color: #22d3ee;
}

.selected{
  background-color: #4b5563;
  border: 1px solid #22d3ee;
  color: #fff;
}

.allow-select{
  cursor: pointer;
}
/*.e-card-content{font-size:14px;line-height:1.5;padding:0 18px 12px 18px}
*/
.sog-card{
}
</style>
